<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    class="stroke-n-slate-7"
  >
    <path
      d="M10.29 3.16394C11.4196 2.94535 12.5805 2.94535 13.71 3.16394"
      stroke-width="1.79999"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.71 20.8362C12.5805 21.0548 11.4196 21.0548 10.29 20.8362"
      stroke-width="1.79999"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.0479 4.54907C18.0032 5.19637 18.8251 6.02134 19.4688 6.97906"
      stroke-width="1.79999"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.16394 13.7101C2.94535 12.5806 2.94535 11.4196 3.16394 10.2901"
      stroke-width="1.79999"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.4515 17.0482C18.8042 18.0035 17.9792 18.8254 17.0215 19.4691"
      stroke-width="1.79999"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.8359 10.2901C21.0545 11.4196 21.0545 12.5806 20.8359 13.7101"
      stroke-width="1.79999"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.54883 6.95205C5.19612 5.99673 6.0211 5.17481 6.97881 4.53107"
      stroke-width="1.79999"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.95223 19.4512C5.99692 18.8039 5.175 17.9789 4.53125 17.0212"
      stroke-width="1.79999"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 14.25C13.7259 14.25 15.125 12.8509 15.125 11.125C15.125 9.39911 13.7259 8 12 8C10.2741 8 8.875 9.39911 8.875 11.125C8.875 12.8509 10.2741 14.25 12 14.25Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17 19.25C17 17.9239 16.4732 16.6521 15.5355 15.7144C14.5979 14.7767 13.3261 14.25 12 14.25C10.6739 14.25 9.40215 14.7767 8.46447 15.7144C7.52678 16.6521 7 17.9239 7 19.25"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
